type CarrierCardActionState = {
	isSelection: boolean;
	isSelected: boolean;
	isBookingDisabled: boolean;
	isReratePrevCarrier?: boolean;
	enableTenderOnBook: boolean;
	isRerate: boolean;
	isCarrierFinalized: boolean;
	isExpired: boolean;
	isSimulated: boolean;
	isAdHocCarrier: boolean;
	isComplete: boolean;
};

const getLabel = ({
	isSelection,
	isSelected,
	isReratePrevCarrier,
	enableTenderOnBook,
	isRerate,
	isCarrierFinalized,
	isExpired,
}: CarrierCardActionState) => {
	if (isSelection) return isSelected ? "Selected" : "Book";
	if (isReratePrevCarrier) return "Go Back";
	const useTenderLabel = enableTenderOnBook && !isRerate;
	if (isCarrierFinalized) return useTenderLabel ? "Tendered" : "Booked";
	if (isExpired) return "Expired";
	return useTenderLabel ? "Tender" : "Book";
};

export const getCarrierCardAction = (state: CarrierCardActionState) => ({
	label: getLabel(state),
	disabled:
		state.isSelected ||
		state.isBookingDisabled ||
		(!state.isSelection &&
			!state.isReratePrevCarrier &&
			(state.isCarrierFinalized ||
				state.isExpired ||
				state.isSimulated ||
				(state.isAdHocCarrier && !state.isComplete))),
	variant:
		state.isCarrierFinalized || !state.isExpired || state.isSimulated
			? ("primary" as const)
			: ("secondary" as const),
});
